import React from 'react'
import UploadIcon from '../Icons/outline/UploadIcon'

function MultiFileInput({
  accept,
  handleFileUpload,
  label,
  small,
  large,
  top,
  className,
  labelClass,
  id,
  buttonText,
}) {

  const onChange = (e) => {
    handleFileUpload(e);
  }

  return (
    <>
      {label && <label id={id} className={`font-semibold text-secondary my-auto ${labelClass}`}>{label}</label>}
      <div className={`flex items-center ${top && 'flex-col'}  ${className}`} id={id}>
        <label htmlFor='uploadFile' className={`px-4 text-secondary hover:bg-light cursor-pointer flex items-center justify-center bg-white border border-gray-300 rounded ${!large &&  'py-1.5 px-2'} ${small && 'py-3 px-2 text-sm'} ${large && 'py-3 px-2 text-lg'}`}>
          <UploadIcon />
          <span className='ml-2'>{buttonText ? buttonText : 'Upload'}</span>
        </label>
        <input type='file' id='uploadFile' multiple={true} className='hidden' accept={ accept ? accept : ''} onChange={onChange}/>
      </div>
    </>
  )
};

export default MultiFileInput;